// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/route-selection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/route-selection/route-selection.js';

mount([g0]);
